import {useDebounce} from '@react-hook/debounce';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {SearchIcon} from '@heroicons/react/solid';
import AvatarCircle from '@/components/basic/AvatarCircle';
import {ImageDownload} from '@/components/ImageUpload';
import Link from 'next/link';
import {useRouter} from 'next/router';

const Searchbar = () => {
  const [value, setValue] = useState('');
  const [term, setTerm] = useDebounce(null);
  const [results, setResults] = useState([]);

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setTerm(null);
      setResults([]);
    };

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      if (term === null || term.length < 3) {
        setResults([]);
        return;
      }

      try {
        const response = await axios.get('/api/search', {
          params: {
            search: term
          }
        });

        setResults(response.data);
      } catch (error) {
        console.error();
        setResults([]);
      }
    };

    fetchData();
  }, [term]);

  return (
    <div className="flex items-center w-full">
      <SearchIcon className="hidden md:block w-6 h-6 mr-3 ml-9 text-primary-dark-100" aria-hidden="true"/>

      <label htmlFor="search" className="sr-only text-primary-dark-100">Search</label>

      <div className="relative w-full">
        <input
          id="search"
          name="search"
          className="mb-6 md:mb-0 py-2 pr-3 leading-5 border-none focus:border-transparent placeholder:text-primary-dark-100 h-14 focus:placeholder-gray-400 text-primary-dark-100 w-full rounded md:rounded-none"
          placeholder="Search"
          type="search"
          onChange={(e) => {
            setTerm(e.target.value)
            setValue(e.target.value)
          }}
          value={value}
        />

        {results && results.length > 0 && (
          <ul className="md:absolute bg-white top-full left-0 w-full md:shadow rounded md:rounded-b text-primary-dark-100 overflow-hidden z-20">
            {results.map((client) => (
              <li key={client.id} className="">
                <Link href={{
                  pathname: '/clients/[client_id]',
                  query: {
                    client_id: client.id
                  }
                }}>
                  <div className="flex items-center p-3 hover:bg-primary-25">
                    <ImageDownload
                      className="rounded-full"
                      id={client.logo_id}
                      altPlaceholder={<AvatarCircle text="LOGO" />}
                    />
                    <span className="pl-3">
                  {client.name}
                </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Searchbar;
